var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { padding: "20px" } },
    [
      _c("div", { staticClass: "title" }, [_vm._v("美团渠道配置")]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "account_box",
          staticStyle: {
            background: "#fff",
            padding: "30px",
            "border-radius": "20px",
          },
        },
        [
          _c(
            "div",
            { staticClass: "mt20" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "200px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "美团会员授权开关", prop: "authEnabled" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.authEnabled,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "authEnabled", $$v)
                            },
                            expression: "ruleForm.authEnabled",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("关闭"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("打开"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm.authEnabled === 1
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "70%" },
                          attrs: {
                            label: "美团开放平台clientId",
                            prop: "clientId",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "" },
                            model: {
                              value: _vm.ruleForm.clientId,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "clientId", $$v)
                              },
                              expression: "ruleForm.clientId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.ruleForm.authEnabled === 1
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "70%" },
                          attrs: {
                            label: "美团开放平台clientSecret",
                            prop: "clientSecret",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "" },
                            model: {
                              value: _vm.ruleForm.clientSecret,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "clientSecret", $$v)
                              },
                              expression: "ruleForm.clientSecret",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "70%" },
                      attrs: { label: "iosUniversalLink", prop: "" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: true, placeholder: "" },
                            model: {
                              value: _vm.ruleForm.iosUniversalLink,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "iosUniversalLink", $$v)
                              },
                              expression: "ruleForm.iosUniversalLink",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              on: {
                                click: function ($event) {
                                  return _vm.copy(_vm.ruleForm.iosUniversalLink)
                                },
                              },
                            },
                            [_vm._v("复制")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "70%" },
                      attrs: { label: "h5网页授权回调地址", prop: "" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { disabled: true, placeholder: "" },
                            model: {
                              value: _vm.ruleForm.redirectUri,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "redirectUri", $$v)
                              },
                              expression: "ruleForm.redirectUri",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              on: {
                                click: function ($event) {
                                  return _vm.copy(_vm.ruleForm.redirectUri)
                                },
                              },
                            },
                            [_vm._v("复制")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("ruleForm")
                            },
                          },
                        },
                        [_vm._v("保存")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }